import React, { useState } from "react";
import CustomSelect from "../../controls/CustomSelect";

export default function CustomPrescriptionTypeDropdown({
  selectedPrescriptionCategory,
  setSelectedPrescriptionCategory,
  setPrescriptionError,
  isDisabled,
}) {
  // Define prescription type options
  const prescriptionTypeOptions = [
    "Private Prescription",
    "Private PGD",
    "Pharmacy First",
  ];

  // Create mapping for values
  const prescriptionTypeMapping = {
    "Private Prescription": "private",
    "Private PGD": "pgd",
    "Pharmacy First": "pharmacy-first",
  };

  // Reverse mapping to get display name from value
  const getDisplayName = (value) => {
    return (
      Object.keys(prescriptionTypeMapping).find(
        (key) => prescriptionTypeMapping[key] === value
      ) || ""
    );
  };

  const handlePrescriptionTypeChange = (selectedDisplayName) => {
    // Get the corresponding value
    const selectedValue = prescriptionTypeMapping[selectedDisplayName];

    // Update the prescription category with the value
    setSelectedPrescriptionCategory(selectedValue || "");

    // Clear any prescription errors if a valid selection is made
    if (selectedValue && setPrescriptionError) {
      setPrescriptionError("");
    }
  };

  return (
    <div className="prescription-type-dropdown-wrapper">
      <CustomSelect
        label="Select prescription type:"
        isDisabled={isDisabled}
        value={getDisplayName(selectedPrescriptionCategory)}
        options={prescriptionTypeOptions}
        onChange={handlePrescriptionTypeChange}
        required={true}
      />
    </div>
  );
}
